import { render, staticRenderFns } from "./DownloadBackup.vue?vue&type=template&id=69778c0d&"
import script from "./DownloadBackup.vue?vue&type=script&lang=js&"
export * from "./DownloadBackup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports